import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"bottom":"","value":_vm.showTooltip,"color":"black","max-width":300},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
return [_c('div',_vm._b({staticClass:"m-button-select-tooltip",on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},'div',attrs,false),[_c('m-button-select',_vm._g(_vm._b({ref:"buttonSelect"},'m-button-select',_vm.$attrs,false),_vm.$listeners))],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])}
var staticRenderFns = []

export { render, staticRenderFns }